'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalActionsList = require('../../../components/modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscriptionErrorView = function SubscriptionErrorView(props) {
    var error = props.error,
        isGuest = props.isGuest,
        dispatchNavigateToRootWorkspace = props.dispatchNavigateToRootWorkspace,
        dispatchNavigateToLogin = props.dispatchNavigateToLogin,
        clearError = props.clearError;


    var guestActions = [{ text: 'Log in', func: dispatchNavigateToLogin }];
    var loggedInActions = [{ text: 'Return to your workspace', func: dispatchNavigateToRootWorkspace }];
    var actions = isGuest ? guestActions : loggedInActions;

    actions.unshift({ text: 'Try again', func: clearError });

    return _react2.default.createElement(
        'div',
        { className: 'Subscriptions SubscriptionErrorView' },
        _react2.default.createElement(
            'h2',
            null,
            'Sorry, there was an error'
        ),
        _react2.default.createElement(
            'p',
            null,
            error.message || 'Please try again'
        ),
        _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
    );
};

SubscriptionErrorView.propTypes = {
    error: _propTypes2.default.object.isRequired,
    isGuest: _propTypes2.default.bool,
    dispatchNavigateToRootWorkspace: _propTypes2.default.func.isRequired,
    dispatchNavigateToLogin: _propTypes2.default.func.isRequired,
    clearError: _propTypes2.default.func.isRequired
};

exports.default = SubscriptionErrorView;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/SubscriptionErrorView.js
// module id = 2084
// module chunks = 0